export const ADMIN_TOGGLE_PROPERTY_KEY = 'jira.admin.nin.global.scope.enrolment';
